import { useEffect } from 'react';

import { isTelegram } from '../utils/browser';

const useCustomCSS = () => {
  const injectCSS = (css) => {
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  };

  useEffect(() => {
    if (isTelegram) {
      injectCSS(`
        div#privy-modal-content {
          border-radius: var(--privy-border-radius-lg) !important;  
        }

        @media (min-width: 441px) {
          [id^="headlessui-dialog-panel-"] {
            position: relative !important;
            transform: none !important;
            transition: none !important;
            opacity: 1 !important;
          }
        }

        @media (max-width: 440px) {
          [id^="headlessui-dialog-panel-"] {
            position: relative !important;
            transform: none !important;
            transition: none !important;
            opacity: 1 !important;
          }
        }

        [id^="headlessui-dialog-panel-"] {
          position: relative !important;
          transform: none !important;
          transition: none !important;
          opacity: 1 !important;
        }
      `);
    }
  }, [isTelegram]);
};

export default useCustomCSS;
